import { Modal, Typography } from "@codat/orchard-ui";
import { useGetSigninMessage } from "api/portal";
import { useUserState } from "portal-ui-remote/UserStateContext";
import React, { useCallback, useState } from "react";
import { useCookies } from "react-cookie";

const SigninMessageModal = () => {
  const { userState } = useUserState();
  const [signinMessage] = useGetSigninMessage();
  const [cookies, setCookie] = useCookies(["signin-seen"]);

  const [dismissed, setDismissed] = useState(!!cookies["signin-seen"]);

  const dismiss = useCallback(() => {
    setCookie("signin-seen", true, { path: "/" });
    setDismissed(true);
  }, [setCookie]);

  if (dismissed || !signinMessage.data?.message || !userState) {
    return <></>;
  }

  return (
    <Modal data-testid="signin-message-modal" size="small" onClose={dismiss}>
      <>
        <Modal.Header
          title={`Welcome to ${userState.clientName}`}
          onClose={null}
        />
        <Modal.Body variant="light">
          <Modal.Section variant="fill">
            <Typography as="p" variant="body_md">
              {signinMessage?.data?.message}
            </Typography>
          </Modal.Section>
        </Modal.Body>
        <Modal.Footer
          variant="dark"
          buttons={[
            {
              label: "Continue",
              onClick: dismiss,
              variant: "primary",
              color: "action",
              "data-testid": "continue",
            },
          ]}
        />
      </>
    </Modal>
  );
};

export default SigninMessageModal;
